import { styled } from '@mui/material/styles';
import { Paper } from '@mui/material';

export const MapContainer = styled(Paper)(({ theme }) => ({
  position: 'relative',
  alignItems: 'stretch',
  width: '100%',
  margin: theme.spacing(0),
  [theme.breakpoints.down('sm')]: {
    height: '100%'
  },
  height: 'calc(100% - 48px)',
  '&.exportPage': {
    height: 554
  },
  '&.dashboardPage': {
    height: '100%'
  },
  '&.dashboardPage, &.deviceOverviewPage': {
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100% - 56px)',
      marginTop: 56
    }
  },
  '@media (max-width: 900px) and (orientation: landscape)': {
    height: 375
  },
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  backgroundColor: 'transparent'
}));
